import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const BuildingTypeSelector = ({
  onChanged,
  isMulti,
  selectedId,
}) => {
  const [buildings, setBuildings] = useState([]);

  useEffect(() => {
    Api.get('types/building-types?per_page=200').then((response) => {
      if (response.status === 200) {
        const mappedValues = response.data.data.map(building => ({
          label: `${building.name} [${building.code}]`,
          value: building.id,
        }));
        setBuildings(mappedValues);
      }
    });
  }, []);
  let selectedItem;
  if (selectedId) {
    if (Array.isArray(selectedId)) {
      selectedItem = buildings.filter(x => Array.from(selectedId).includes(x.value));
    } else {
      selectedItem = buildings.find(x => x.value === selectedId);
    }
  }
  return (
    <Select
      isMulti={isMulti}
      options={buildings}
      value={selectedItem}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Building Type"
    />
  );
};

BuildingTypeSelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.number,
};

BuildingTypeSelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: undefined,
};

export default BuildingTypeSelector;
